import { type BillingInfo, packCredits } from "~/protocol/billing";

// What /billing says about automatic top-up (billing/topup.ts): the setting as one line for every
// member, and the notice an admin sees once a refused charge has turned it off.

export const creditsCount = (n: number) => `${n} ${n === 1 ? "credit" : "credits"}`;

/** The setting as one line, for everyone who can see the billing view. */
export function topUpSummary(b: Pick<BillingInfo, "topUp">): string {
  if (!b.topUp) return "Off.";
  const { pack, threshold } = b.topUp;
  return `On. When credits fall below ${threshold}, your org's saved card buys the $${pack} pack (${creditsCount(packCredits(pack))}), plus tax.`;
}

export const TOP_UP_FAILED =
  "Automatic top-up is off because a top-up couldn't be charged to your org's card. Nothing was charged and no credits were added. To use it again, update the card in Manage billing, then turn top-up on.";
